module.exports = __webpack_public_path__ + "static/img/main_search.3b0653bf.svg";